import './expandedSelectField.scss';
import React from 'react';
import classNames from 'classnames';
import ImageCheckbox from '../imageCheckbox/ImageCheckbox';
import InputField from '../inputField/InputField';

type SelectValue = string | number;

type ExpandedSelectItem = {
    value: SelectValue;
    label: string;
    selected?: boolean;
    isSelected?: boolean;
};

type ExpandedSelectFieldProps = {
    label?: string;
    items: ExpandedSelectItem[];
    selectedItem?: SelectValue;
    onChangeHandler?: (value: SelectValue) => void;
};

type SelectedStateItem = {
    value: SelectValue | '';
    selected: boolean;
};

type ExpandedSelectFieldState = {
    selectedItem: SelectedStateItem;
    menuVisible: boolean;
};

type SelectItemProps = {
    label: string;
    selected?: boolean;
    onClick: () => void;
};

const SelectItem = ({ label, selected, onClick }: SelectItemProps) => (
    <div title={label} className="b-expanded-select-item" onClick={onClick}>
        <label>{label}</label>
        <ImageCheckbox check={!!selected} />
    </div>
);

class ExpandedSelectField extends React.Component<
ExpandedSelectFieldProps,
ExpandedSelectFieldState
> {
    constructor(props: ExpandedSelectFieldProps) {
        super(props);

        const selectedItem = props.selectedItem ?? '';

        this.state = {
            selectedItem: {
                value: selectedItem,
                selected: !!selectedItem,
            },
            menuVisible: false,
        };
    }

    updateSelected(selectedItem: SelectedStateItem) {
        const { onChangeHandler = () => null } = this.props;

        if (typeof onChangeHandler !== 'undefined') {
            onChangeHandler(selectedItem.value);
        }

        this.setState({
            selectedItem,
            menuVisible: false,
        });
    }

    onSelect(item: SelectedStateItem, isSelected?: boolean) {
        if (!isSelected) {
            this.updateSelected(item);
        }
    }

    toggleMenu() {
        this.setState(state => ({
            menuVisible: !state.menuVisible,
        }));
    }

    getSelectionLabel() {
        const { items } = this.props;
        const { selectedItem } = this.state;
        let label = '';

        items.forEach((item) => {
            if (item.value === selectedItem.value) {
                label = item.label;
            }
        });

        return label;
    }

    render() {
        const { selectedItem, menuVisible } = this.state;
        const { label = '', items = [] } = this.props;

        const itemsWithSelection = items.map((item) => ({
            ...item,
            isSelected: item.value === selectedItem.value,
        }));

        const menuClasses = classNames({
            'b-expanded-select-menu': true,
            'is-visible': menuVisible,
        });

        const selectFieldClasses = classNames({
            'b-expanded-select-field': true,
            'is-focused': menuVisible,
            'is-filled': !!(selectedItem.value && selectedItem.value !== ''),
        });

        const inputWrapperClasses = classNames({
            'input-wrapper': true,
        });

        return (
            <div
                className={selectFieldClasses}
            >
                <div className="b-expanded-select-container">
                    <div className={inputWrapperClasses} onClick={this.toggleMenu.bind(this)}>
                        <InputField
                            label={label}
                            name={label}
                            disabled
                            value={this.getSelectionLabel()}
                            isFocused={menuVisible}
                        />
                    </div>
                    <div className={menuClasses}>
                        {
                            itemsWithSelection.map((item, index) => {
                                const itemLabel = item.label;

                                return (
                                    <SelectItem
                                        key={index}
                                        label={itemLabel}
                                        selected={item.isSelected}
                                        onClick={this.onSelect.bind(this, item as SelectedStateItem, item.isSelected)}
                                    />
                                );
                            })
                        }
                    </div>
                </div>
            </div>
        );
    }
}

export default ExpandedSelectField;